import React from 'react'
import useList from 'hooks/useList'
import ChannelPkgList from 'biz-components/ChannelPkgList'
import OperationList from 'biz-components/OperationList'
import Button from '@tencent/spaui-button'
import { getAppList, getAppListParams } from '../utils/network'
import showBindAppDialog from '../utils/showBindAppDialog'
let splitViewInstance = null

const useAppList = () => {
    const { state, setState } = useList({
        updateDataAPI: getAppList,
        genUpdateDataAPIParams: getAppListParams,
    })
    const showChannelPkgList = (rowData, e) => {
        e.preventDefault()
        splitViewInstance && splitViewInstance.show(<ChannelPkgList {...rowData} />)
    }
    const showOperationList = (rowData, e) => {
        e.preventDefault()
        splitViewInstance && splitViewInstance.show(<OperationList {...rowData} />)
    }
    const colRender = (type, name, value, rowData) => {
        if (type !== 'head') {
            // 已下线app
            if (rowData && rowData.offLine) {
                let text = value
                if (name === 'operate') {
                    text = '-'
                } else if (name === 'name') {
                    text = `${rowData.name}【应用已下线】`
                }
                return <span style={{ color: 'red' }}>{text}</span>
            }
            // 正常上线状态app
            if (name === 'operate') {
                return (
                    <>
                        <Button
                            className="spaui-add-button"
                            displayType="link"
                            style={{ marginLeft: '0px', padding: '0px' }}
                            useBaseClass={false}
                            onClick={e => showChannelPkgList(rowData, e)}
                        >
                            查看渠道包
                        </Button>
                        <Button
                            className="spaui-add-button"
                            displayType="link"
                            style={{ marginLeft: '0px', padding: '0px' }}
                            useBaseClass={false}
                            onClick={e => showOperationList(rowData, e)}
                        >
                            投放账号管理
                        </Button>
                    </>
                )
            }
            return value
        }
        return value
    }
    const setSplitViewInstance = el => {
        splitViewInstance = el
    }

    const handleAddButtonClick = e => {
        e.preventDefault()
        showBindAppDialog({
            ...setState,
        })
    }

    return { colRender, state, setState, setSplitViewInstance, handleAddButtonClick }
}

export default useAppList
